<template>
        <div>
            <NavHeader />
            <div class="main-header-content">
                <div class="container">
                    <h3>About Us</h3>
                </div>
            </div>
            <div class="divider"></div>

            <div class="about-us-content">
                <div class="container">
                    <p class="content-para text-center">eRemit is an online money transfer service by Merchantrade Asia (Merchantrade), Malaysia’s largest licensed Money Services Business Provider with over 27 years of industry excellence. Its cross-border money transfer service offers a seamless and secure way to transfer money from Malaysia to over 200 countries and territories, including the UK, US, Australia, New Zealand, Singapore, China, India, Indonesia, Bangladesh, Nepal, Pakistan, the Philippines, Myanmar, Sri Lanka, Thailand, and Vietnam.</p>

                    <p class="content-para text-center">Available 24/7, eRemit ensures reliable cross-border money transfers directly from your account to your recipient. </p>

                    <p class="content-para text-center">Merchantrade is committed to delivering exceptional digital financial services, including international money transfers, currency exchange, wholesale currency, mobile prepaid services and micro-insurance. This commitment is supported by a robust physical network of branches and digital presence, with 95 branches, 5 wholesale banknote trading hubs, and over 480 agent locations throughout Malaysia. </p>
                        <img src="/static/commercial/img/line-draw.png" alt="">
                </div>
            </div>

            <div class="divider"></div>
            <div class="container">
                <div class="award-slider">
                    <h3 class="award-header">Award Winning Money Transfer Service</h3>


             
                        <slick ref="slick" :options="vModel.slickOptions" class="items-slider slider">
                            <div class="items">
                                <div class="award-image">
                                    <img src="/static/commercial/img/award01.png">
                                </div>

                                <div class="detail">
                                    <p class="pos">Winner</p>
                                    <h3>Best Brands In e-Commerce Digital Remittance</h3>
                                    <p class="title">The Brand Laureate</p>
                                    <p class="year">2016-2017</p>
                                </div>
                            </div>

                            <div class="items">
                                <div class="award-image">
                                    <img src="/static/commercial/img/award02.png">
                                </div>

                                <div class="detail">
                                    <p class="pos">Winner</p>
                                    <h3>Best Retails Money Transfer Operator</h3>
                                    <p class="title">IAMTN</p>
                                    <p class="year">2016</p>
                                </div>

                            </div>



                            <div class="items">
                                <div class="award-image">
                                    <img src="/static/commercial/img/award03.png">
                                </div>

                                <div class="detail">
                                    <p class="pos">Winner</p>
                                    <h3>Best Brands In e-Commerce Digital Remittance</h3>
                                    <p class="title">The Brand Laureate</p>
                                    <p class="year">2016-2017</p>
                                </div>

                            </div>



                            <div class="items">
                                <div class="award-image">
                                    <img src="/static/commercial/img/award01.png">
                                </div>

                                <div class="detail">
                                    <p class="pos">Winner (Community Vote)</p>
                                    <h3>Best Remittance Breathrough Transfer</h3>
                                    <p class="title">Florin Awards Asia</p>
                                    <p class="year">2016</p>
                                </div>


                            </div>
                        </slick>
                  
                </div>
            </div>

            <div class="divider"></div>
            <div class="container">
                <div class="partners-slider">
                    <h3 class="partners-header">Partners We Value & Work With</h3>

                  
                        <slick ref="slicks" :options="vModel.slickOptionsTwo" class="partner-logo-slider slider">

                            <div class="items">
                                <img src="/static/commercial/img/partners/logo01.png" alt="">
                            </div>
                            <div class="items">
                                <img src="/static/commercial/img/partners/logo02.png" alt="">
                            </div>
                            <div class="items">
                                <img src="/static/commercial/img/partners/logo03.png" alt="">
                            </div>
                            <div class="items">
                                <img src="/static/commercial/img/partners/logo04.png" alt="">
                            </div>
                            <div class="items">
                                <img src="/static/commercial/img/partners/logo05.png" alt="">
                            </div>
                        </slick>
                   
                </div>
            </div>

            <div class="divider"></div>













        </div>
    </template>
    <script>
import Slick from "vue-slick";
import DownloadApp from "../../shared/commercial/DownloadApp.vue";
import NavHeader from "../../shared/commercial/NavHeader.vue";
import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";

export default {
  name: "AboutUs",
  components: { DownloadApp, NavHeader, SignUpFooter, Slick },
  created() {},
  data() {
    return {
      ExchangeRateCollection: [],
      RecentTransactionCollection: [],
      NotificationCollection: [],

      RecipientCollection: null,
      ClassBadge: { "badge-yellow": true },
      itemTemplate:
        '<div class="m-b-sm m-t-sm">#:data.Fullname# <br/><img style="width:24px;" src="static/img/flags/#:data.FlagCode#.png" />#:data.CountyName#<br/> #:data.PayoutMode#</div>',
      vModel: {
        slickOptions: {
          dots: false,
          infinite: true,
          mobileFirst: true,
          slidesToScroll: 1,
          slidesToShow: 3,
          navigation: true,
          variableWidth: true,
          autoplay : true,
        autoplaySpeed: 1000
        },
        slickOptionsTwo: {
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          autoplay : true,
          autoplaySpeed: 1000,
          navigation: true,
          responsive: [
            {
              breakpoint: 1150,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 6
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 5
              }
            },
            {
              breakpoint: 550,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 3
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    }
  }
};
</script>
